

























import Vue from 'vue'
import Component from 'vue-class-component'
import {Action, State} from 'vuex-class'
import Event from '@/modules/reservation/model/Event'
import {Prop} from 'vue-property-decorator'
import {Colors, notify} from '@/modules/core/notification'

/**
 * Selector de evento
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class EventSelect extends Vue {
    @Prop({
        type: Event,
        default: () => (new Event()),
    })

    public value: Event;

    /**
     * Etiqueta para el campo
     */
    @Prop({type: String, default: 'Seleccionar evento de reservas'})
    public label: string;

    @Prop({type: Array, default: () => []})
    public rules: Array<() => boolean | string>;

    @Prop({type: Boolean, default: false})
    public dense: boolean

    /**
     * Lista de eventos cargados en la aplicación
     */
    @State(state => state.reservation.events)
    public events: Event[];

    /**
     * Acción del estado que carga la lista de eventos desde la API
     */
    @Action('reservation/loadEventList')
    public loadEventList: () => void;

    public loading = true;

    public async created () {
        await this.loadEventList();
        this.loading = false;
    }

    public errorCaptured (error: Error) {
        notify('Se ha producido un error al carga los eventos', Colors.Error)
        this.loading = false
    }
}
